import type * as React from 'react';

import type { Xinglet } from '@xing-com/crate-xinglet';

import { PageHome } from './page-home/page-home';

export default class Test implements Xinglet {
  public getComponent(): React.FC {
    return (): JSX.Element => {
      return <PageHome />;
    };
  }
}
